import { Injectable } from '@angular/core';
import { Http} from '@angular/http';
import { environment } from '../../../../../environments/environment';
import 'rxjs/add/operator/toPromise';
import {EnvUtils, StorageUtils} from '../../../utils';
import {MsgPopupService} from '../msg-popup.service';
import {KeycloakloginService} from '../keycloaklogin.service';
import {EnvLoadService} from '../../../../env-load/env-load.service';
import {IntegratedKeycloakloginService} from '../integrated.keycloaklogin.service';


@Injectable()
export class CommonServices {
    private apiUrl = `${environment.apiUrl}/api/v1`;
    private companyId = '';
    andebug = false;

    constructor(private http: Http,
                private keycloakloginService: KeycloakloginService,
                private integratedKeycloakloginService: IntegratedKeycloakloginService,
                private envLoadService: EnvLoadService,
                private _msgPopupService: MsgPopupService) {
        this.andebug = StorageUtils.getItem('an.debug') === 'd' ? true : false;
    };

    /**
     * COMMON
     * Service 조회
     * Method : Get
     * API No : 1.01
     * /api/v1/{cmpnNo}/common/service?searchWord={searchWord}&page={page}&rows={rows}&oidx={oidx}
     * 서비스 리스트를 조회해오는 API
     * **/
    getService(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/service${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * COMMON
     * Integration Group 조회
     * Method : Get
     * API No : 1.02
     * /api/v1/{cmpnNo}/common/integration/group?searchWord={searchWord}&page={page}&rows={rows}&oidx={oidx}
     * 인티그레이션 그룹 리스트를 조회해오는 API
     * **/
    getIntegrationGroup() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/integration/group`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * COMMON
     * Integration 조회
     * Method : Get
     * API No : 1.03
     * /api/v1/{cmpnNo}/common/integration?searchWord={searchWord}&page={page}&rows={rows}&oidx={oidx}
     * 인티그레이션 그룹 리스트를 조회해오는 API
     * **/
    getIntegration() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/integration`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * COMMON
     * Escalation Rule list 조회
     * Method : Get
     * API No : 1.06
     * /api/v1/{cmpnNo}/escalation?searchWord={searchWord}&page={page}&rows={rows}
     * 에스컬레이션 룰 리스트를 조회해오는 API
     * Remark : Type 이 team인경우 팀에 연결되지 않은 에스컬레이션만 조회됨
     * **/
    getEscalationRule(queryString?) {
        // const queryString = (type === undefined ? '' : '?type=' + type);
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/escalation${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * COMMON
     * Code List
     * Method : Get
     * API No : 1.27
     * /api/v1/{cmpnNo}/code/query/{cdGrpCd}
     * 공통코드를 그룹별로 조회해오는 API
     * **/
    getCode(cdGrpCd: string, type?: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/code/query/${cdGrpCd}${(type === undefined) ? '' : '?type=LANG'}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * COMMON
     * Code List
     * Method : Get
     * API No : 1.04
     * /api/v1/{cmpnNo}/common/member
     * 공통코드를 그룹별로 조회해오는 API
     * **/
    getMember(queryString?: any) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/member${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * COMMON
     * Code
     * Method : Get
     * API No :
     * /api/v1/{cmpnNo}/code/{cdId}
     * 코드 정보를 조회해오는 API
     * **/
    getCodeInfo(cdId: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/code/${cdId}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * GNB
     * Homepage Info 조회
     * Method: Get
     * API No : 12.01
     * /api/v1/{cmpnNo}/common/homepageinfo?host={host}
     */
    getHomePageInfo() {
        let host = window.location.hostname;
        if (process.env.ENV === 'dqa') {
        // if (global['envCd'] === 'dqa' || global['envCd'] === 'dev') {
            host = 'alertnowdev.opsnow.com';
        }
        // TODO: opsnow360 demo 후에 복원?
        if (global['envCd'] === 'dev') {
            host = 'alertnowdev.opsnow360.com';
        }

        if (host === 'alertnow0.opsnow.com') {
            host = 'alertnow.opsnow.com';
        }

        if (host === 'alertnow0.opsnow.cn') {
            host = 'alertnow.opsnow.cn';
        }

        if (host === 'alertnow.sec-alertnow.com') {
            host = 'www.sec-alertnow.com';
        }

        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/homepageinfo?host=${host}`;
        if (this.andebug) console.log('>>> getHomePageInfo(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(response => response)
            .catch(this.handleError);
    }

    /**
     * GNB
     * 유저권한 그룹별 고객사 목록 조회
     * Method: Get
     * API No : 12.02
     * /api/v1/{cmpnNo}/common/companylist
     */
    getCompanyList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/companylist`;
        if (this.andebug) console.log('>>> getCompanyList(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(response => response)
            .catch(this.handleError);
    }

    /**
     * GNB
     * 유저 권한 그룹별 메뉴 목록 조회
     * Method: Get
     * API No : 12.03
     * /api/v1/{cmpnNo}/common/menulist?langCd={langCd}
     */
    getMenuList(cmpnId: string, langCd: string) {
        const url = `${this.apiUrl}/${cmpnId}/common/menulist?langCd=${langCd}`;
        if (this.andebug) console.log('>>> getMenuList(cmpnId: string, langCd: string): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    // /earth/api/portal/authgroup/menuList/
    getEarthMenuList(cmpnId: string) {
        const url = `${this.apiUrl}/${cmpnId}/common/menulist`;
        if (this.andebug) console.log('>>> getEarthMenuList(cmpnId: string): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * GNB
     * 화면에 선택된 고객사 정보 Portal에 저장
     * Method: Put
     * API No : 12.04
     * /api/v1/{cmpnNo}/common/current/company
     */
    updateLastSelectCompany(cmpnId: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/current/company`;
        if (this.andebug) console.log('>>> updateLastSelectCompany(cmpnId: string): ' + url);

        const postData: any = {
            portalCmpnId: cmpnId
        };

        return this.http
            .put(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * GNB
     * 공지사항 목록 조회
     * Method: Get
     * API No : 12.05
     * /api/v1/{cmpnNo}/common/notilist
     */
    getNotiList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/notilist`;
        if (this.andebug) console.log('>>> getNotiList(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * GNB
     * 공지사항 not read 및 scroll Text Data 조회
     * Method: Get
     * API No : 12.06
     * /api/v1/{cmpnNo}/common/scrolltext
     */
    getScrolltext() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/scrolltext`;
        if (this.andebug) console.log('>>> getScrolltext(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * COMMON
     * column 중복 체크
     * Method: Get
     * API No : 1.08
     * /api/v1/{cmpnNo}/common/duplicate?type={type}&column={column}&value={value}
     *
     * type
     * ESCAL : TLCS_ESCAL_PLCY_M
     * SVC : TCOM_SVC_M
     * ITGR : TLTS_ITGR_APPL_INSTL_L
     * ITGR_GRP : TLTS_ITGR_CNFG_GRP_M
     *
     */
    getDuplicate(queryString?: string) {
        const queryParam = (queryString === undefined ? '' : queryString);
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/duplicate${queryParam}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * GNB
     * Session정보 조회 조회
     * Method: Get
     * API No : 1.09
     * /api/v1/{cmpnNo}/common/session
     * remark
     *      로그인 이전의 경우 엑세스 토큰을 던지면 해당 엑서스 토큰에 해당하는 유저 정보가 리턴됨
     *      로그인 이후의 경우 회사코드를 던지면 유저정보가 리턴됨
     */
    // 최초 로그인 정보 가져올 때 사용 (비동기 방식)
    getSessionToPromise(param) {
        const url = `${this.apiUrl}/${param}/common/session`;
        if (this.andebug) console.log('>>> getSessionToPromise(param): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.errorHandler); //this.redirect);
    }

    // 화면 guard 에서 로그인 정보 가져옴 (동기 방식)
    getSessionMap(param) {
        const url = `${this.apiUrl}/${param}/common/session`;
        if (this.andebug) console.log('>>> getSessionMap(param): ' + url);

        return this.http
            .get(url)
            .map(res => {
                const loginUserData = res.json().data;
                const userRole = {
                    userId: loginUserData.portalUserId,
                    userNm: loginUserData.userNm,
                    cmpnId: loginUserData.currPortalCmpnId,
                    roleCd: loginUserData.roleCd,
                    rolePrms: loginUserData.rolePrms
                };
                return userRole;
            });
    }

    /**
     * Common
     * 로그인시 사용자의 타임존을 업데이트
     * Mothod : Put
     * API No : 1.13
     * /api/v1/{cmpnNo}/common/timezone
     **/
    updateUserTimezone(putData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/timezone`;

        return this.http
            .put(url, JSON.stringify(putData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * Common
     * 언어 변경시 사용자의 타임존을 업데이트
     * Mothod : Put
     * API No : 1.13
     * /api/v1/{cmpnNo}/common/language/{langCd}
     **/
    updateUserLanguage(langCd: any, userNo?) {
        const path = userNo !== undefined ? 'users/' + userNo : 'common';
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/${path}/language/${langCd}`;

        return this.http
            .put(url, '')
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * Common
     * 최근 방문 기록 저장
     * Mothod : Post
     * API No : 1.13
     * /api/v1/{cmpnNo}/common/recent/menu
     */
    createRecentMenu(postData: any) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/recent/menu`;

        return this.http
            .post(url, JSON.stringify(postData))
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * Common
     * 최근 방문 기록 조회
     * Method: Get
     * API No : 1.14
     * /api/v1/{cmpnNo}/common/recent/menu/{langCd}
     */
    getRecentMenu(langCd: string) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/recent/menu/${langCd}`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    getLanguageList() {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/language`;

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    // getSessionToPromise API 에러 핸들러.
    private errorHandler(error: any) {
        console.error('세션 조회 An error occurred', error);

        const redirect_url = window.location.origin;

        if (global['envCd'] === 'loc' || global['envCd'] === 'dev'
            && error.ok === false
            && error.status === 0
            && error.type === 3) {

            const tokenKey = EnvUtils.envCdToTokenKey();
            const refreshKey = EnvUtils.envCdToRefreshKey();
        

            setTimeout(() => {
                const token = $.cookie(tokenKey);
                $.cookie(tokenKey, null, {domain: global['sub_domain'], expires: -1});
                $.cookie(refreshKey, null, {domain: global['sub_domain'], expires: -1});
                this.integratedKeycloakloginService.logout({'redirectUri' : global['logOutUrl']});
            }, 1);
        }

        if (error.status === 401) {
            const responder = JSON.parse(error._body).responder;
            if (this.andebug) console.log('401: ', responder);

            //SSO 401인 경우
            if (responder === undefined || responder === '') {
                if (this.andebug) console.log('401 if');

            } else {        //401이면서 responder가 있는경우
                const redirectUrlCd = JSON.parse(error._body).redirectUrlCd;
                if (this.andebug) console.log('401 else');

                if (redirectUrlCd === 'portal') {
                    this._msgPopupService.msgEvent.emit({
                        'header_msg' : 'MK.00792',   // 권한 없음
                        'contents_msg' : 'MK.00790', // 서비스 가입 정보가 존재하지 않습니다.
                        'close_btn_use_flag' : false
                    });

                    setTimeout(() => {
                        location.href = `${global['urlInfo'].opsnow360Url}`;
                    }, 3000);
                }
            }
        } else if (error.status === 403) {
            const responder = JSON.parse(error._body).responder;
            const messageKey = JSON.parse(error._body).messageKey;
            if (this.andebug) console.log('403: ', responder, messageKey);

            if (responder === undefined || responder === '' || messageKey === 'MK.00972' || messageKey === 'MK.01904') {
                if (this.andebug) console.log('403 if');

            } else {
                if (this.andebug) console.log('403 else');

                this._msgPopupService.msgEvent.emit({
                    'header_msg' : 'MK.00792',   // 권한 없음
                    'contents_msg' : 'MK.00947', // 액세스 거부됨
                    'close_btn_use_flag' : false
                });
            }
        }

        setTimeout(() => {
            $('.spinner').removeClass('spinner');
        }, 1500);

        return Promise.reject(error.message || error);
    }

    /**
     * Type TT001: My Team
     *      TT002: Other Team
    **/
    getTeamList(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/team?${queryString}`;
        if (this.andebug) console.log('>>> getTeamList(queryString): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    // 화면 resource guard, split view 에서 접근 권한 확인 (동기 방식)
    getResourceAccessibleMap(curCmpnId, rsrcType, rsrcNo) {
        const url  = `${this.apiUrl}/${curCmpnId}/common/${rsrcType}/${rsrcNo}/acsb`;
        if (this.andebug) console.log('>>> getResourceAccessibleMap(curCmpnId, rsrcType, rsrcNo): ' + url);

        return this.http
            .get(url)
            .map(res => {
                return res.json().data.length;
            })
            .catch(this.handleError);
    }

    // objectlink 에서 접근 권한 확인 (비동기 방식)
    getResourceAccessibleToPromise(curCmpnId, rsrcType, rsrcNo) {
        const url  = `${this.apiUrl}/${curCmpnId}/common/${rsrcType}/${rsrcNo}/acsb`;
        if (this.andebug) console.log('>>> getResourceAccessibleToPromise(curCmpnId, rsrcType, rsrcNo): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => {
                return res.json().data.length;
            })
            .catch(this.handleError);

    }

    private handleError(error: any) {
        //console.error('An error occurred', error);
        return Promise.resolve(error.message || error);
    }

    /**
     * 공지사항 목록 조회
     * Method: Get
     * API No : 12.05
     * /api/v1/{cmpnNo}/common/notices
     */
    getNoticeList(queryString) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/notices?${queryString}`;
        if (this.andebug) console.log('>>> getNoticeList(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }

    /**
     * GNB
     * 공지사항 목록 조회
     * Method: Get
     * API No : 12.05
     * /api/v1/{cmpnNo}/common/notices
     */
    getNoticeDetail(noticeId) {
        const url = `${this.apiUrl}/${global['loginUser'].curCmpnId}/common/notices/${noticeId}`;
        if (this.andebug) console.log('>>> getNoticeList(): ' + url);

        return this.http
            .get(url)
            .toPromise()
            .then(res => res)
            .catch(this.handleError);
    }
}






// WEBPACK FOOTER //
// ./src/app/shared/services/src/api/common.services.ts